import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  ref, watch,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  variant: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
},
  emits: ['input'],
  setup(__props, { emit }) {





const modelValue = ref<boolean>(false);

watch(modelValue, () => {
  emit('input', modelValue.value);
});

return (_ctx: any,_cache: any) => {
  const _component_o_switch = _resolveComponent("o-switch")!

  return (_openBlock(), _createBlock(_component_o_switch, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    variant: __props.variant
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.label), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "variant"]))
}
}

})